export default __webpack_public_path__ + "media/images/work_with_us/work_hero_md-466c63e1baece85fa54a5847ff277532.png";